import { Redirect, Route, Switch } from "wouter";
import { AdminKayttajat } from "./admin-kayttajat.js";
import { Asetukset } from "./asetukset.js";
import { Historia } from "./historia.js";
import { Lataa } from "./lataa.js";
import { Levyt } from "./levyt.js";
import { Onboard } from "./onboard.js";
import { ProjectDetail } from "./project-detail.js";
import { ProjectsList } from "./projects-list.js";
import { Selaa } from "./selaa.js";
import { Tervetuloa } from "./tervetuloa.js";

// 1.D.2 Sivurakenne. Routit ovat placeholder-tasoa — Selaa, Asset-detail
// ja muut taeytetaan 1.D.3..1.D.9:ssa.

function Page({ title, hint }: { title: string; hint: string }) {
  return (
    <section className="mx-auto max-w-6xl px-6 py-10">
      <h2 className="text-2xl font-semibold tracking-tight">{title}</h2>
      <p className="mt-2 text-slate-400">{hint}</p>
    </section>
  );
}

function Home() {
  return (
    <Page
      title="Tervetuloa"
      hint="Aloita Selaa-sivulta tai katso TODO-listasta mita pitaa tehda."
    />
  );
}
function Todo() {
  return (
    <Page
      title="TODO"
      hint="Toimenpiteet, paatokset ja ehdotukset (1.A.6 todos-skeema, UI tulee myohemmin)."
    />
  );
}
function NotFound() {
  return <Page title="404" hint="Sivua ei loytynyt." />;
}

export function Routes() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      {/* /login on App-tasolla auth-gaten taakse — kirjautuneen vierailu redirectaa kotiin. */}
      <Route path="/login">
        <Redirect to="/" />
      </Route>
      <Route path="/onboard" component={Onboard} />
      <Route path="/todo" component={Todo} />
      <Route path="/selaa" component={Selaa} />
      <Route path="/projektit" component={ProjectsList} />
      <Route path="/projektit/:id" component={ProjectDetail} />
      <Route path="/levyt" component={Levyt} />
      <Route path="/historia" component={Historia} />
      <Route path="/asetukset" component={Asetukset} />
      <Route path="/kayttajat" component={AdminKayttajat} />
      <Route path="/lataa" component={Lataa} />
      <Route path="/tervetuloa" component={Tervetuloa} />
      <Route component={NotFound} />
    </Switch>
  );
}
